const Events = require('PSEvents');
const HistoryRow = require('HistoryRow');
const PageSelector = require('PageSelector');

const State = cc.Enum({
    INIT: 'init',
    IDLE: 'idle'
});

cc.Class({
    extends: cc.Component,

    properties: {
        rowsContainerLandscape: cc.Node,
        rowPrefabLandscape: cc.Prefab,
        rowsContainerPortrait: cc.Node,
        rowPrefabPortrait: cc.Prefab,
        pageSelector: PageSelector
    },

    onLoad () {
        this.state = State.INIT;
        Events.subscribe(Events.ROUND_HISTORY_RECEIVED, (data) => {
            this.setData(data);
        })
        this.pageSelector.node.on('pageUpdated', (page) => {
            this._cleanGrid();
            Events.publish(Events.ROUND_HISTORY_REQUEST, page - 1)
        });
        this.rowsLandscape = [];
        this.rowsPortrait = [];


        for (let i = 0; i < 10; i ++) {
            const row = cc.instantiate(this.rowPrefabLandscape);
            this.rowsContainerLandscape.addChild(row);
            const rowComponent = row.getComponent(HistoryRow);
            rowComponent.setEmptyData();
            this.rowsLandscape.push(rowComponent);
        }
        this.rowsContainerLandscape.getComponent(cc.Layout).updateLayout();

        for (let i = 0; i < 10; i ++) {
            const row = cc.instantiate(this.rowPrefabPortrait);
            this.rowsContainerPortrait.addChild(row);
            const rowComponent = row.getComponent(HistoryRow);
            rowComponent.setEmptyData();
            this.rowsPortrait.push(rowComponent);
        }
        this.rowsContainerPortrait.getComponent(cc.Layout).updateLayout();
    },

    onEnable () {
        this._cleanGrid();
    },

    onDisable () {
        this.state = State.INIT;
    },

    _cleanGrid () {
        for (let i = 0; i < 10; i ++) {
            this.rowsLandscape[i].setEmptyData();
            this.rowsPortrait[i].setEmptyData();
        }
    },

    _updatePage () {
        for (let i = 0; i < 10; i ++) {
            if (this.data.data[i]) {
                this.rowsPortrait[i].setData(this.data.data[i]);
                this.rowsLandscape[i].setData(this.data.data[i]);
            } else {
                this.rowsPortrait[i].setEmptyData();
                this.rowsLandscape[i].setEmptyData();
            }
        }
    },

    setData (data) {
        this.data = data;
        this._updatePage();
        if (this.state === State.INIT) {
            this.state = State.IDLE;
            this.pageSelector.setData(data.paging);
        }
    }
});
